import { createContext } from "react";

const DashboardContext = createContext<unknown>(undefined);

export default DashboardContext;
